export const MAX_BOUNDS = [
    [-170, -55], // Southwest coordinates
    [200, 75], // Northeast coordinates
  ];

export const MIN_ZOOM = 1;
export const MAX_ZOOM = 3;
export const LONGITUDE_FLIP = 50;
  
export const DEFAULT_MAP_STATE = {
    maxZoom: MAX_ZOOM,
    minZoom: MIN_ZOOM,
    zoom: 0,
    longitude: 0,
    latitude: 0,
};

export const DROPDOWN_CATEGORY = [
  'W10', 
  'Europe & UK', 
  'CIS', 
  'East Asia', 
  'South Asia', 
  'Southeast Asia & Oceania', 
  'Americas', 
  'Middle East', 
  'Africa'
];